import request from '@/router/axios'

export function getPage(params) {
  return request({
    url: '/api/produce/base-spare-part-apply/select/page',
    method: 'get',
    params,
  })
}

export function getList(params) {
  const p = { ...params }
  if (p.page != null && p.current == null) {
    p.current = p.page
    delete p.page
  }
  return getPage(p)
}

function idParam(id) {
  return id != null && id !== '' ? String(id) : id
}

export function getById(id) {
  return request({
    url: '/api/produce/base-spare-part-apply/select/id',
    method: 'get',
    params: { id: idParam(id) },
  })
}

/** 璁惧缁翠繚 sourceType=2锛氭寜 sourceId锛堢淮淇濊鍒?id锛夋煡璇㈤鐢ㄧ敵璇峰垪琛紙鍚槑缁嗭級 */
export function listApplyByMaintenancePlan(sourceId) {
  return request({
    url: '/api/produce/base-spare-part-apply/select/list-by-maintenance-plan',
    method: 'get',
    params: { sourceId: idParam(sourceId) },
  })
}

export function add(data) {
  return request({
    url: '/api/produce/base-spare-part-apply/add',
    method: 'post',
    data,
  })
}

export function updateApply(data) {
  return request({
    url: '/api/produce/base-spare-part-apply/update',
    method: 'post',
    data,
  })
}

export function approve(id, approverId, approverName, remark) {
  return request({
    url: '/api/produce/base-spare-part-apply/approve',
    method: 'get',
    params: { id: idParam(id), remark },
  })
}

export function reject(id, approverId, approverName, remark) {
  return request({
    url: '/api/produce/base-spare-part-apply/reject',
    method: 'get',
    params: { id: idParam(id), remark },
  })
}

export function confirmReceive(id, remark) {
  return request({
    url: '/api/produce/base-spare-part-apply/confirm-receive',
    method: 'get',
    params: { id: idParam(id), remark },
  })
}

/** 纭澶囦欢宸插綊杩橈紙鐘舵€?2鈫?锛?*/
export function confirmReturn(data) {
  return request({
    url: '/api/produce/base-spare-part-apply/confirm-return',
    method: 'post',
    data,
  })
}

export function exportExcel(params) {
  const p = { ...params }
  if (p.page != null && p.current == null) {
    p.current = p.page
    delete p.page
  }
  return request({
    url: '/api/produce/base-spare-part-apply/export/excel',
    method: 'post',
    data: p,
    responseType: 'blob',
  })
}

export function deleteById(id) {
  return request({
    url: '/api/produce/base-spare-part-apply/delete/id',
    method: 'get',
    params: { id: idParam(id) },
  })
}


